import * as _4 from 'lodash4';
import { ICourseSection } from '../../study_group_interfaces';

export class StudyGroupTermsController {
  private sections: ICourseSection[];
  private termName: string;
  private hasTerms: boolean = true;

  $onInit() {
    this.hasTerms = !_4.isEmpty(this.sections);
  }
}

export class StudyGroupTermsComponent implements angular.IComponentOptions {
  public templateUrl: string = 'capability-ng-study-groups/src/components/study_group_terms/study_group_terms.html';
  public controller: any = StudyGroupTermsController;
  public controllerAs: string = '$ctrl';
  public bindings: any = {
    termName: '<',
    sections: '<'
  };
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-study-groups/src/components/study_group_terms/study_group_terms_component.ts